__turbopack_context__.v({
  "loading": "page-module-scss-module__rcUngW__loading",
  "scrollArea": "page-module-scss-module__rcUngW__scrollArea",
  "scrollAreaContent": "page-module-scss-module__rcUngW__scrollAreaContent",
  "streamStatsPageContent": "page-module-scss-module__rcUngW__streamStatsPageContent",
});
